import { DynamicIcon } from '@purpur/library/dynamic-icon';
import type { IconName } from '@purpur/library/icon';

interface Props {
  iconName: IconName;
  size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const PurpurIcon = ({ iconName, size = 'md', className }: Props) => {
  return <DynamicIcon name={iconName} size={size} className={className} />;
};

export default PurpurIcon;

export { type IconName } from '@purpur/library/icon';
